module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASBAMAAACk4JNkAAAAG1BMVEX///95fYZ0fIN1e4Rze4J0e4NzeYJzeoJzeoJesAfaAAAACHRSTlMCO2d4ib2/3UUduHQAAAABYktHRACIBR1IAAAARUlEQVQI12NgYGBLACEgEDYvNjYvNgSyIjpAoBXISgPLpoFYTAoMTApgFkgxmExjAyqDyrq4uJAmi5eFcIGICwg4MiAAAGvzG8NY5Mu5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/my-repair.png
// module id = 2G/9
// module chunks = 1